// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2czbe","left":"styles_left__3lHkS"};